import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const RestoreSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default RestoreSVG;
